import React, { useState, useEffect, useRef } from 'react';
import logo from '../assets/images/logo.png';
import { Link, NavLink } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { destroySession, isAuthenticated } from '../helpers/functions';
import { persistor } from '../redux/store';
import AuthInfo from '../components/utilities/auth-info/info';
import { handleLogout } from '../redux/authentication/actionCreator';
import { useDispatch } from 'react-redux';
import './Header.css';
import useBusinessChatUnread from '../hooks/useBusinessChatUnread';
import { formatUnreadCount } from '../helpers/chatUtils';

function Header({ hide }) {
    const history = useHistory();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const headerDropdownRef = useRef(null);
    const dispatch = useDispatch();
    const unreadCount = useBusinessChatUnread();
    const chatBadgeLabel = formatUnreadCount(unreadCount);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleSignout = async () => {
        destroySession();
        await persistor.purge();
        await dispatch(handleLogout());
        history.push('/login-customer');
    };

    const toggleDropdownOnClickOutside = (event) => {
        if (
            headerDropdownRef.current &&
            !headerDropdownRef.current.contains(event.target)
        ) {
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', toggleDropdownOnClickOutside);
        return () => {
            document.removeEventListener(
                'mousedown',
                toggleDropdownOnClickOutside
            );
        };
    }, []);

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light container pt-4 mb-2">
                <div className="container-fluid">
                    <Link className="navbar-brand" to={hide ? '#' : '/home'}>
                        <div className="logo-wrapper">
                            <img src={logo} alt="Logo" />
                        </div>
                    </Link>
                    {/* <button
                        className="navbar-toggler d-lg-none d-block border-0"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasDarkNavbar"
                        aria-controls="offcanvasDarkNavbar"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button> */}
                    <div
                        className="offcanvas offcanvas-end custom-mobile-sidebar d-lg-none d-block"
                        tabIndex="-1"
                        id="offcanvasDarkNavbar"
                        aria-labelledby="offcanvasDarkNavbarLabel"
                    >
                        <div className="offcanvas-header pt-4 px-3">
                            <img
                                src={logo}
                                alt="Logo"
                                style={{ width: '110px' }}
                            />
                            <button
                                type="button"
                                className="btn-close-custom"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                                        fill="white"
                                    />
                                </svg>
                            </button>
                        </div>
                        <div className="offcanvas-body px-3">
                            <div className="d-flex flex-column mt-3">
                                <NavLink
                                    to="/customer/profile-setting"
                                    className="nav-link-custom cp"
                                    activeClassName="active"
                                    onClick={() => {
                                        const closeBtn = document.querySelector('#offcanvasDarkNavbar .btn-close-custom');
                                        if (closeBtn) closeBtn.click();
                                        toggleDropdown();
                                    }}
                                >
                                    Profile Settings
                                </NavLink>
                                <NavLink
                                    to="/customer/chat"
                                    className="nav-link-custom cp d-flex align-items-center justify-content-between gap-2"
                                    activeClassName="active"
                                    onClick={() => {
                                        const closeBtn = document.querySelector('#offcanvasDarkNavbar .btn-close-custom');
                                        if (closeBtn) closeBtn.click();
                                    }}
                                >
                                    <span>Messages</span>
                                    {chatBadgeLabel && (
                                        <span
                                            style={{
                                                backgroundColor: '#ff4d4f',
                                                color: '#ffffff',
                                                borderRadius: '50%',
                                                width: '18px',
                                                height: '18px',
                                                fontSize: '10px',
                                                fontWeight: '600',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                lineHeight: '1',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            {chatBadgeLabel}
                                        </span>
                                    )}
                                </NavLink>
                                <a
                                    className="nav-link-custom cp"
                                    data-bs-dismiss="offcanvas"
                                    onClick={() => {
                                        handleSignout();
                                    }}
                                >
                                    Logout
                                </a>
                            </div>
                        </div>
                    </div>
                    {isAuthenticated() ? (
                        <AuthInfo />
                    ) : (
                        <div className="d-flex gap-3">
                            <Link
                                className="btn btn-outline-light text-black rounded-pill border-0 text-decoration-underline f-16 fw-normal poppins py-md-11 px-md-20 my-2"
                                to={'/register-customer'}
                            >
                                Sign up
                            </Link>
                            <Link
                                className="btn btn-outline-light text-black rounded-pill border-0 text-decoration-underline f-16 fw-normal poppins py-md-11 px-md-20 my-2"
                                to={'/login-customer'}
                            >
                                Login
                            </Link>

                            <Link
                                className="btn btn-light rounded-pill f-16 fw-normal poppins py-md-11 px-md-20 my-2"
                                to={'/register'}
                            >
                                Create Business Account
                            </Link>
                        </div>
                    )}
                </div>
            </nav>
        </>
    );
}

export default Header;
